import { motion } from "framer-motion";
import { STEPS } from "@/content";
import { MaskLines, Overline, Reveal } from "@/components/site/Reveal";

export const Process = () => (
  <section id="process" className="relative overflow-hidden border-y border-rc-line bg-rc-bg2 py-28 lg:py-40" data-testid="process-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Overline>How to Get Started</Overline>
      <MaskLines
        lines={["Four steps from", <>first note to <em className="italic text-rc-copper">final</em> mix.</>]}
        className="mt-8 font-display text-4xl font-medium leading-[1.02] tracking-tight text-rc-ink sm:text-5xl lg:text-6xl"
      />
      <div className="relative mt-20">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
          className="absolute left-0 right-0 top-[38px] hidden h-px origin-left bg-rc-copper/50 lg:block"
        />
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.14} className="group relative" data-testid={`process-step-${s.no}`}>
              <div className="relative z-10 grid h-[76px] w-[76px] place-items-center rounded-full border border-rc-copper/60 bg-rc-bg2 transition-[background-color] duration-500 group-hover:bg-rc-copper">
                <span className="font-display text-3xl italic text-rc-copper transition-colors duration-500 group-hover:text-rc-bg">{s.no}</span>
              </div>
              <h3 className="mt-8 font-display text-3xl text-rc-ink">{s.title}</h3>
              <p className="mt-3 max-w-xs text-base leading-relaxed text-rc-body">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
